import React from 'react'

import {
    StyledIconButton,
    StyledIconButtonAnchorTag,
    PixelOffset,
} from '../../buttons/IconButton/IconButton.styled'

export interface IconButtonProps {
    link: string
    type?: React.ButtonHTMLAttributes<any>['type']
    baseColor: string
    className?: string
    iconScale?: number
    icon: React.ReactElement<any>
    useAnchorTag?: boolean
    noBorder?: boolean // does not draw a border if set
    offset?: PixelOffset // position override for when Icon is not to be centered automatically
}

export const IconButton: React.FC<IconButtonProps> = ({
    link,
    baseColor,
    icon,
    iconScale,
    className,
    useAnchorTag,
    noBorder,
    offset,
}) => {
    return useAnchorTag ? (
        <StyledIconButtonAnchorTag
            href={link}
            baseColor={baseColor}
            iconScale={iconScale}
            className={className}
            noBorder={noBorder}
            offset={offset}
        >
            {icon}
        </StyledIconButtonAnchorTag>
    ) : (
        <StyledIconButton
            to={link}
            baseColor={baseColor}
            iconScale={iconScale}
            className={className}
            noBorder={noBorder}
            offset={offset}
        >
            {icon}
        </StyledIconButton>
    )
}
IconButton.displayName = 'IconButton'
